import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { PersonCircle } from 'react-bootstrap-icons';
import './about.css';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';
import NidhiImg from "../../Assets/img/Testimonials/Nidhi Chaudhary.jpeg"
import AniImg from "../../Assets/img/Testimonials/Ani Titus.jpg"
import BhoomikaImg from "../../Assets/img/Testimonials/Bhoomika Padhalni.jpg"
import PragatiImg from "../../Assets/img/Testimonials/Pragati.jpg"
import HarshdeepImg from "../../Assets/img/Testimonials/Harshdeep.jpg"
import AishwaryaImg from "../../Assets/img/Testimonials/Aishwarya .jpg"
import ShivaniImg from "../../Assets/img/Testimonials/Shivaani Sharrma.jpeg"
import nidhiImg from "../../Assets/img/Testimonials/Nidhi Srivastava.jpg"
import KirtiImg from "../../Assets/img/Board/Kirti Mehta.jpeg"
import KomalImg from "../../Assets/img/Testimonials/Komal Farwaha.jpeg"
import SikhaImg from "../../Assets/img/Testimonials/Shikha Saboo1.jpg"
import GeetaImg from "../../Assets/img/Testimonials/Dr. Geeta Shukla.jpg"
import RituImg from "../../Assets/img/Testimonials/Ritu Goel.jpeg"
import RomaImg from "../../Assets/img/Testimonials/Roma Kumar.jpg"
import VkImg from "../../Assets/img/Testimonials/VK Anil Kumar.jpeg"
import AnuragImg from "../../Assets/img/Testimonials/Anurag Jain.jpg"
import RoopaliImg from "../../Assets/img/Testimonials/Roopali Charan.jpg"
import SanjuImg from "../../Assets/img/Testimonials/Sanju Swarnakar.jpg"
import VivekImg from "../../Assets/img/Testimonials/Vivek Tripathi.jpg"
import PawanImg from "../../Assets/img/Testimonials/Pawan Uppal.jpg"
import KavitaImg from "../../Assets/img/Testimonials/Kavita Soni.jpg"
import SubhadraImg from "../../Assets/img/Testimonials/Subhadra Rai.jpeg"
import SoniaImg from "../../Assets/img/Testimonials/Sonia Abraham.jpg"
import RenukaImg from "../../Assets/img/Testimonials/Renuka Bhuta.jpg"
import HymavathiImg from "../../Assets/img/Testimonials/Hymavathi Garuda.jpg"
import PriyankaJImg from "../../Assets/img/Testimonials/Priyanka Jaiswal.jpg"
import AditiImg from "../../Assets/img/Testimonials/Aditi.jpg"
import KanchanImg from "../../Assets/img/Testimonials/Kanchan.jpg"
import JosephImg from "../../Assets/img/Testimonials/Joseph John.jpg"
import PoonamImg from "../../Assets/img/Testimonials/Poonam Shah.jpg"
import SairaImg from "../../Assets/img/Testimonials/Saira Banu.jpg"
import AnjuImg from "../../Assets/img/Testimonials/Anju.jpeg"
import VibhaImg from "../../Assets/img/Testimonials/Vibha Gandhi.jpg"
import MeghanaImg from "../../Assets/img/Testimonials/meghana.jpg"
import MonikaImg from "../../Assets/img/Testimonials/monika.jpg"
import NithyaImg from "../../Assets/img/Testimonials/nithya.jpg"
import NeahaahImg from "../../Assets/img/Testimonials/neahaah.jpg"
import HarshdeepSImg from "../../Assets/img/Testimonials/Harshdeep.jpg"
import MinalImg from "../../Assets/img/Testimonials/minal.jpeg"
import ShipraImg from "../../Assets/img/Testimonials/Shipra.jpeg"

const committeesData = [
  // {
  //   committee: "Policy, Standards & Recognition",
  //   members: [
  //     { name: "Ritu Goel", role: "Committee Head",img: RituImg, description: "Ritu Goel, with 20+ years of experience in people management, administration, HR, and marketing communications, leads APCCI's Policy & Standardization Committee. A certified career coach trained in NLP and DEIB principles, she focuses on policy development, process improvement, and compliance, ensuring consistent, high-quality career guidance. Her strategic expertise shapes industry standards, making APCCI a trusted platform for counselors. Beyond work, she enjoys travel, volunteering, and rally driving. Committed to excellence, Ritu strives to build a well-structured, ethical, and impactful career counseling ecosystem." },
  //     { name: "Roma Kumar", role: "Deputy Head", img: RomaImg },
  //     { name: "Harshdeep Singh",role: "Member" ,img: HarshdeepImg},
  //     { name: "Pragati Imam",role: "Member" ,img: PragatiImg},
  //     { name: "Nidhi Chaudhary",role: "Member", img: NidhiImg },
  //   ]
  // },
  // {
  //   committee: "Membership Management",
  //   members: [
  //     { name: "Bhoomika Padhalini",img:BhoomikaImg ,role: "Committee Head", description: "Bhoomika Padhalni is a certified Career Counselor (UCLA Extension - Univariety) with 15+ years of experience in career guidance, HR, and talent acquisition. As an APCCI Board Member & Head of Membership Management, she strengthens India’s career counseling ecosystem through strategy and collaboration. Her expertise spans career roadmaps, emerging careers, psychometric assessments, and industry insights. Passionate about guiding students, she bridges education with real-world opportunities, empowering them to make informed, future-ready decisions for long-term success." },
  //     { name: "Komal Farwaha", role: "Deputy Head", img: KomalImg },
  //     { name: "Kirti Mehta",role: "Member", img: KirtiImg},
  //     { name: "Sanju Swarnakar",role: "Member", img: SanjuImg },
  //     { name: "Kanchan AG", role: "Member", img: KanchanImg },
  //   ]
  // },
  // {
  //   committee: "Training & Research",
  //   members: [
  // { name: "Shikha Saboo", role: "Committee Head", img:SikhaImg , description: "Shikha Saboo is an Educational Consultant and Communication Coach with over 10 years of experience in overseas education, communication and mindset coaching. As a Head of Training and Capacity Building Committee at APCCI, she contributes to designing and executing global training frameworks for career counsellors. Through her work experience and XLNC Pioneers Portal, she provides a holistic career development pathway. Her expertise in coaching, training and profile building strengthens APCCI’s role in empowering the career counsellors to support the ecosystem." },
  // { name: "Nidhi Srivastava", role: "Deputy Head", img: nidhiImg },
  // { name: "Pragati Imam", role: "Deputy Head", img: PragatiImg },
  // { name: "Dr Sonia Abraham", role: "Research Head", img: SoniaImg },
  // { name: "Priyanka Jaiswal", role: "Member", img: PriyankaJImg },
  // { name: "Nidhi Choudhary", role: "Member", img: NidhiImg },
  // { name: "Anurag Jain", role: "Member", img: AnuragImg },
  // { name: "Renuka Bhuta", role: "Member", img: RenukaImg },
  // { name: "Aishwarya", role: "Member", img: AishwaryaImg },
  // { name: "Roopali Charan", role: "Member", img: RoopaliImg },
  //   ]
  // },
  // {
  //   committee: "Marketing and Publications",
  //   members: [
  //     { name: "Ani Titus", role: "Head - Marketing and Publications", img: AniImg, description: "Ani Titus, Co-Founder and Partnership Lead at Ask A Student, drives global collaborations and student engagement. As the Marketing Head of APCCI, she leads strategic branding, outreach, and engagement initiatives. A Certified Global Career Counsellor (UCLA) and APCDA member with nearly 20 years of professional experience, she specializes in career mentorship, educational consulting, and fostering peer connections. She builds trusted student communities and develops impactful university partnerships, helping students make informed study decisions in India and abroad. Passionate about making a difference, she goes the extra mile to support student success." },
  // { name: "Kavita Soni", role: "Deputy Head", img: KavitaImg },
  // { name: "Shivaani Sharma", role: "Member", img: ShivaniImg },
  // { name: "Pawan Uppal", role: "Member", img: PawanImg },
  //   ]
  // },
  // {
  //   committee: "Research & Knowledge Creation",
  //   members: [
  //     { name: "Dr Geeta Shukla", role: "Committee Head", img: GeetaImg, description: "Dr. Geeta Shukla, with 36+ years of experience in teaching, training, and educational leadership, holds a PhD in Chemistry and a B.Ed. She has impacted thousands of students and educators as a teacher, principal, and CBSE Master Trainer, conducting 200+ workshops on career guidance, mental health, and life skills. As Head of the Research & Knowledge Creation Committee at APCCI, she drives research initiatives and develops structured methodologies for career counseling. Her dedication strengthens APCCI’s mission to enhance career guidance across India, including support for underprivileged children." },

  //     { name: "Vivek Tripathi", role: "Member", img: VivekImg },

  //     { name: "Subhadra Rai", role: "Member", img: SubhadraImg },
  //     { name: "Shiwani Beniwal", role: "Member" },
  //     { name: "V K Anil Kumar", role: "Member", img: VkImg },
  //     { name: "Hymavathi Garuda", role: "Member", img: HymavathiImg },

  //     { name: "Aditi Mittal", role: "Member", img: AditiImg },
  //   ]
  // },
  // {
  //   committee: "Outreach & Partnerships",
  //   members: [
  //     { name: "Kanchan AG", role: "Head - Outreach & Partnerships", img: KanchanImg, description: "Kanchan AG, a seasoned career counselor and educational consultant, leads APCCI's Outreach & Partnerships Committee. With extensive experience in building strategic alliances, she focuses on fostering collaborations with educational institutions, industry partners, and international organizations. Her expertise in career guidance and student mentorship enables her to create impactful programs that enhance the reach and effectiveness of APCCI's initiatives. Kanchan is dedicated to expanding the network of career counselors and promoting best practices in career counseling across India." },
  //   ]
  // },

  {
    committee: "Meet our Volunteers - The People Behind APCCI",
    members: [
      { name: "Ani Titus", role: "Marketing & Publications", img: AniImg, description: "Ani Titus, Co-Founder and Partnership Lead at Ask A Student, drives global collaborations and student engagement. As the Marketing Head of APCCI, she leads strategic branding, outreach, and engagement initiatives. A Certified Global Career Counsellor (UCLA) and APCDA member with nearly 20 years of professional experience, she specializes in career mentorship, educational consulting, and fostering peer connections. She builds trusted student communities and develops impactful university partnerships, helping students make informed study decisions in India and abroad. Passionate about making a difference, she goes the extra mile to support student success." },
      { name: "Dr Sonia Abraham", role: "Newsletter", img: SoniaImg },
      { name: "Pragati Imam", role: "Training & Research", img: PragatiImg },
      { name: "Nidhi Srivastava", role: "Training & Research", img: nidhiImg },
      { name: "Kirti Mehta", role: "Event Support", img: KirtiImg },
      { name: "Poonam Shah", role: "Event Registration", img: PoonamImg },
      { name: "Saira Banu", role: "Social Media Management", img: SairaImg },
      { name: "Renuka Bhuta", role: "Event Support", img: RenukaImg },
      { name: "Dr Geeta Shukla", role: "Awards & Recognition", img: GeetaImg },
      { name: "Anju Nambiar", role: "Content Creator", img: AnjuImg },
      { name: "Vibha Gandhi", role: "Social Media Management", img: VibhaImg },
      { name: "Shipra Anand", role: "Design Support", img: ShipraImg },
      { name: "VK Anil Kumar", role: "Newsletter", img: VkImg },
      { name: "Meghana Shah", role: "Awards & Recognition", img: MeghanaImg },
      { name: "Monika Sundrani", role: "Event Support", img: MonikaImg },
      { name: "Nithya Natarajan", role: "Event Registration", img: NithyaImg },
      { name: "Neahaah Sampat", role: "Event Support", img: NeahaahImg },
      { name: "Harshdeep Singh", role: "Event Support", img: HarshdeepSImg },
      { name: "Minal Kulkarni", role: "Event Support", img: MinalImg },


    ]
  },

];

const CommitteeMemberCard = ({
  member,
  isActive,
  onHover,
  onLeave,
  isHead
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`card border-0 rounded-4 overflow-hidden h-100 ${isActive ? "active" : ""
        }`}
      onMouseEnter={() => {
        setIsHovered(true);
        onHover();
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        onLeave();
      }}
      style={{
        transition: "all 0.35s ease",
        transform: isHovered ? "translateY(-6px)" : "translateY(0)",
        boxShadow: isHovered
          ? "0 15px 35px rgba(36, 65, 131, 0.16)"
          : "0 4px 15px rgba(0, 0, 0, 0.07)",
        background: "#fff",
      }}
    >
      <div className="card-body p-2 p-md-4 text-center d-flex flex-column align-items-center">

        {/* Responsive Profile Image */}
        <div
          className="d-flex justify-content-center align-items-center mb-2 mb-md-3"
          style={{
            width: "clamp(90px, 12vw, 180px)",
            height: "clamp(90px, 12vw, 180px)",
          }}
        >
          {member.img ? (
            <img
              src={member.img}
              alt={member.name}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid #f1f5f9",
              }}
            />
          ) : (
            <PersonCircle
              size={90}
              className="text-secondary opacity-50"
            />
          )}
        </div>

        {/* Name */}
        <h4
          className="fw-bold mb-1"
          style={{
            color: "#2a4b7c",
            fontSize: "clamp(0.85rem, 2vw, 1.2rem)",
            lineHeight: "1.25",
          }}
        >
          {member.name}
        </h4>

        {/* Role */}
        {member.role && (
          <span
            style={{
              color: "#5d89ba",
              fontWeight: "600",
              fontSize: "clamp(0.7rem, 1.7vw, 0.95rem)",
              lineHeight: "1.3",
            }}
          >
            {member.role}
          </span>
        )}
      </div>

      {/* Description for Head cards */}
      {isHovered && isHead && member.description && (
        <div
          className="p-3 bg-light text-center"
          style={{
            borderTop: "1px solid #eee",
            transition: "0.3s",
          }}
        >
          <p
            className="m-0 leading-relaxed text-justify mx-auto"
            style={{ textWrap: "pretty" }}
          >
            {member.description}
          </p>
        </div>
      )}
    </div>
  );
};

const CommitteeSection = ({ committee }) => {
  const [activeCard, setActiveCard] = useState(null);

  const head = committee.members.find(member => member.role === 'Committee Head');
  const members = committee.members.filter(member => member.role !== 'Committee Head');

  // 🔥 Dynamically center-align rows with fewer than 4 cards
  const getRowAlignment = (count) => {
    if (count === 1) return 'justify-content-center';
    if (count === 2 || count === 3) return 'justify-content-center';
    return '';
  };

  return (
    <div className="committee-section mb-5">
      <div className="committee-header text-center mb-4">
        <h2 className="fw-bold" style={{ fontSize: '2rem', color: '#2a4b7c' }}>
          {committee.committee}
        </h2>
        <div className="board-divider" style={{ width: '200px', height: '3px' }}></div>
      </div>

      {/* Head card centered */}
      <Row className={`g-3 g-md-4 ${getRowAlignment(members.length)}`}>
        {members.map((member, idx) => (
          <Col key={idx} xs={6} sm={6} md={4} lg={3}>
            <CommitteeMemberCard
              member={member}
              isActive={activeCard === idx}
              onHover={() => setActiveCard(idx)}
              onLeave={() => setActiveCard(null)}
              isHead={false}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

const FunctionalCommittees = () => {
  return (
    <>
      <PublicHeader />

      <div className="section-header md:mt-[40px] mt-0">
        <div className="header-content px-5">
          <h1 className="display-4 fw-bold mb-2 text-white">
            APCCI Functional Committees
          </h1>
        </div>
        <div className="overlay"></div>
      </div>

      <Container className="py-5">
        {committeesData.map((committee, idx) => (
          <CommitteeSection key={idx} committee={committee} />
        ))}
      </Container>

      {/* Volunteer Registration CTA */}
      <section
        className="mx-3 mx-md-5 mb-5 rounded-4 overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #0078BF 0%, #244183 100%)",
          boxShadow: "0 15px 40px rgba(36, 65, 131, 0.18)",
        }}
      >
        <div className="text-center px-4 py-5">
          <h2
            className="fw-bold text-white mb-3"
            style={{ fontSize: "clamp(1.6rem, 4vw, 2.3rem)" }}
          >
            Want to Volunteer with APCCI?
          </h2>

          <p
            className="text-white mx-auto mb-4"
            style={{
              maxWidth: "700px",
              fontSize: "clamp(0.95rem, 2vw, 1.1rem)",
              opacity: "0.9",
              lineHeight: "1.7",
            }}
          >
            Be a part of our growing community and contribute your skills,
            ideas, and experience to create a meaningful impact.
          </p>

          <a
            href="https://zfrmz.in/HddRHS5u2OczpMZXxwGH"
            target="_blank"
            rel="noopener noreferrer"
            className="d-inline-flex align-items-center justify-content-center gap-2 fw-semibold"
            style={{
              background: "rgba(255, 255, 255, 0.96)",
              color: "#244183",
              padding: "14px 28px",
              borderRadius: "12px",
              textDecoration: "none",
              fontSize: "1rem",
              border: "1px solid rgba(255,255,255,0.7)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.16)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(0,0,0,0.22)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 8px 24px rgba(0,0,0,0.16)";
            }}
          >
            Become an APCCI Volunteer

            <span
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #0078BF, #244183)",
                color: "white",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "17px",
                transition: "transform 0.3s ease",
              }}
            >
              →
            </span>
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default FunctionalCommittees;
